import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PromocaoService } from '../../../../shared/services/apis/scanntech/promocao.service';
import { ListaPromocaoResponse } from '../../../../shared/services/responses/scanntech/lista-promocao.response';
import { Promocao } from '../../../../shared/services/models/scanntech/promocao.model';
import { StatusPromocaoScanntechEnum } from '../../../../shared/enums/scanntech/status-promocao-scanntech.enum';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../../shared/components/loading-box-default-list/loading-box-default-list.component';

@Component({
  selector: 'app-resulth-scanntech-lista',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    CommonModule,
    MatTableModule,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    HeaderComponent,
    LoadingBoxDefaultListComponent,
  ],
  templateUrl: './resulth-scanntech-lista.component.html',
  styleUrl: './resulth-scanntech-lista.component.css',
})
export class ResulthScanntechListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private promocaoService: PromocaoService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Integracao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Integracao_ResulthScanntech;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaPromocaoResponse: ListaPromocaoResponse | undefined;
  public displayedColumns: string[] = ['codigo', 'descricao', 'tipo', 'dataInicial', 'dataFinal'];
  public _dataSource = new MatTableDataSource<Promocao>();

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
    });

    this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading == true) {
      return;
    }

    this._isLoading = true;

    this.promocaoService.getListaPromocoes(StatusPromocaoScanntechEnum.Aceito).subscribe({
      next: (response: ListaPromocaoResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._listaPromocaoResponse = response;
        this._dataSource.data = this._listaPromocaoResponse.listaPromocao;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
